<template>
  <div
    class="layout layout--centered"
    data-test-id="centered-layout"
  >
    <div
      v-if="showLeaderboardAd"
      class="layout__leaderboard-container"
      data-test-id="layout-leaderboard-container"
    >
      <ad-slot mapping="leaderboard" />
    </div>
    <slot name="hero" />
    <div
      id="layout-content"
      class="layout__content"
      data-test-id="layout-content"
    >
      <not-found v-if="is404" />
      <slot v-else />
    </div>
  </div>
</template>

<script>
import AdSlot from '@/components/Ads/AdSlot.vue';
import NotFound from '@/components/Global/NotFound.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'CenteredLayout',
  components: {
    AdSlot,
    NotFound,
  },
  props: {
    showLeaderboardAd: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['is404']),
  },
};
</script>
